import { useEffect } from 'react';
import { useAppDispatch } from '../../store';
import { setIsOnline } from '../../store/slices/global';
export const useOfflineModeDetector = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        const handleOnline = () => dispatch(setIsOnline(true));
        const handleOffline = () => dispatch(setIsOnline(false));
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);
};
